import { APP_NAME } from "configs/AppConfig";
// import { publicGetMethodService } from "services";

export const SETTING_JSON = APP_NAME !== "sportsxzone" ? `https://1xmix.s3.ap-southeast-1.amazonaws.com/control-1xmix.json`: `https://sportsxzone.s3.ap-southeast-1.amazonaws.com/control.json`;

// let domains = {};

// export const fetchDomains = async () => {
//   const res = await publicGetMethodService(SETTING_JSON);
//   domains = {
//     main_domain: APP_NAME !== "sportsxzone" ? process.env.REACT_APP_MAIN_DOMAIN :(res? res?.REACT_APP_MAIN_DOMAIN : process.env.REACT_APP_MAIN_DOMAIN),
//     soccer_domain: APP_NAME !== "sportsxzone" ? process.env.REACT_APP_SOCCER_DOMAIN :(res? res?.REACT_APP_SOCCER_DOMAIN: process.env.REACT_APP_SOCCER_DOMAIN),
//     additional_domain: APP_NAME !== "sportsxzone" ? process.env.REACT_APP_ADDITIONAL_DOMAIN :(res? res?.REACT_APP_ADDITIONAL_DOMAIN: process.env.REACT_APP_ADDITIONAL_DOMAIN),
//     slot_domain: APP_NAME !== "sportsxzone" ? process.env.REACT_APP_SLOT_DOMAIN :(res? res?.REACT_APP_SLOT_DOMAIN: process.env.REACT_APP_SLOT_DOMAIN),
//     lottery_domain: APP_NAME !== "sportsxzone" ? process.env.REACT_APP_LOTTERY_DOMAIN :(res? res?.REACT_APP_LOTTERY_DOMAIN: process.env.REACT_APP_LOTTERY_DOMAIN),
//     config_domain: APP_NAME !== "sportsxzone" ? process.env.REACT_APP_MAIN_DOMAIN :(res? res?.config_api_domain : process.env.REACT_APP_MAIN_DOMAIN),
//   };
// };

// await fetchDomains();
// setInterval(fetchDomains, 1000 * 10);

// let isProduction = process.env.REACT_APP_APP_ENV === 'production';

// const getDomain = (key) => {
//   return isProduction 
//     ? domains[key] || process.env[`REACT_APP_${key.toUpperCase()}`] 
//     : process.env[`REACT_APP_${key.toUpperCase()}`];
// };

const main_domain = process.env.REACT_APP_MAIN_DOMAIN;
const soccer_domain = process.env.REACT_APP_SOCCER_DOMAIN;
const additional_domain = process.env.REACT_APP_ADDITIONAL_DOMAIN;
const slot_domain = process.env.REACT_APP_SLOT_DOMAIN;
const lottery_domain = process.env.REACT_APP_LOTTERY_DOMAIN;
const config_domain = process.env.REACT_APP_MAIN_DOMAIN;

// Main API
export const ADMIN_LOGIN_API = () => `${main_domain}api/main/auth/admin-login`;
export const ADMIN_LOGOUT_API = () => `${main_domain}api/main/auth/logout`;
export const AGENT_LOGIN_API = () => `${main_domain}api/main/auth/login/agent`;
export const CHANGE_PASSWORD_API = () => `${main_domain}api/main/users/change-password`;
export const USERS_BALANCES_API = () => `${main_domain}api/main/users/dashboard/total-balance`;
export const USERS_COUNT_API = () => `${main_domain}api/main/users/dashboard/total-user`;
export const DOWNLINE_PASSWORD_CHANGE_API = id => `${main_domain}api/main/users/change-password/${id}`;
export const USER_DETAIL_API = id => `${main_domain}api/main/users/${id}`;
export const SUB_USERS_API = () => `${main_domain}api/main/users/sub-accounts`;
export const SETTINGS_API = () => `${config_domain}api/main/config?is_cache=false`;
export const EDIT_SETTINGS_API = () => `${config_domain}api/main/config/update`;
export const USER_CREATE_API = () => `${main_domain}api/main/users`;
export const USER_EDIT_CONFIG_API = id => `${main_domain}api/main/users/config/${id}`;
export const USER_EDIT_COMMISSION_API = id => `${main_domain}api/main/users/commission/${id}`;
export const PAYMENT_SUBMIT_API = () => `${main_domain}api/main/wallets/payments`;
export const WITHDRAW_BONUS_API = () => `${main_domain}api/main/wallets/withdrawal-bonus`;

export const DEPOSIT_HISTORY_API = () => `${main_domain}api/main/wallets/payments/member/deposit-histories`;
export const DEPOSIT_STATUS_API = () => `${main_domain}api/main/wallets/payments/member/confirm-deposit`;

export const WITHDRAW_HISTORY_API = () => `${main_domain}api/main/wallets/payments/member/withdrawal-histories`;
export const WITHDRAW_STATUS_API = () => `${main_domain}api/main/wallets/payments/member/confirm-withdrawal`;
export const PAYS_API = () => `${main_domain}api/main/wallets/payments/methods`;
export const ACCOUNTS_API = () => `${main_domain}api/main/wallets/payments/accounts`;
export const PENDINT_DEPOSIT_COUNT = () => `${main_domain}api/main/wallets/payments/member/deposit-count/pending`;
export const PENDINT_WITHDRAW_COUNT = () => `${main_domain}api/main/wallets/payments/member/withdrawal-count/pending`;
export const PAYMENT_REPORT_API = () => `${main_domain}api/main/wallets/payments/v2/reports`;
export const APPLY_AGENT_API = () => `${main_domain}api/main/agent-requests`;
export const PENDINT_APPLY_AGENT_COUNT = () => `${main_domain}api/main/agent-requests/pending-count`;
export const CONTACT_INFO_API = () => `${main_domain}api/main/contact-infos`;
export const TOTAL_SMS_COUNT_API = () => `${main_domain}api/main/config/get-sms-balance`;
export const BONUS_INFO_API = () => `${main_domain}api/main/wallets/bonus-info`;



// Slot API
export const SLOT_BETTING_API = () => `${slot_domain}api/games/slot/slot-bettings`;
export const GAME_BALANCE_API = () => `${slot_domain}api/games/slot/game-balance`;
export const SLOT_BALANCE_API = () => `https://syscasino.com/api/games/slot/max-accept-limit`;

// Soccer API
export const TEX_SETTING_UPDATE_API = id => `${soccer_domain}api/soccer/bettings/tax-percent/${id}`;
export const FIXTURES_API = () => `${soccer_domain}api/soccer/fixtures/third-party/upcomming-events`;
export const SEARCH_FIXTURES_API = () => `${soccer_domain}api/soccer/fixtures/third-party/search-events`;
export const FIXTURE_API = () =>  `${soccer_domain}api/soccer/fixtures`;
export const FIXTURES_UPDATE_API = id =>  `${soccer_domain}api/soccer/fixtures/${id}`;
export const FIXTURES_OPEN_ALL_API = () => `${soccer_domain}api/soccer/fixtures/all/change-is-published`
export const LEAGUES_API = () => `${soccer_domain}api/soccer/fixtures/leagues`;
export const ODDS_API = id => `${soccer_domain}api/soccer/fixtures/third-party/odds/${id}`;
export const LIVE_GOALS_API = id => `${soccer_domain}api/soccer/fixtures/third-party/events/${id}`
export const RESULT_CONFIRM_API = id => `${soccer_domain}api/soccer/fixtures/confirm-score/${id}`
export const RESULT_REJECT_API = id => `${soccer_domain}api/soccer/fixtures/reject-score/${id}`;
export const REJECT_SLIP_API = id => `${soccer_domain}api/soccer/bettings/reject/${id}`
export const TEAMS_API = () => `${soccer_domain}api/soccer/fixtures/names`;
export const EDIT_TEAM_API = id => `${soccer_domain}api/soccer/fixtures/names/${id}`;
export const TEAM_IMAGE = (data) => {
  let encodedString = data?.code;
    return `${soccer_domain}api/soccer/fixtures/images/${encodedString}/teams/${data?.name_en}`;
  };
export const ROLLBACK_API = id => `${soccer_domain}api/soccer/fixtures/rollback-score/${id}`;
export const TRANSLATE_API = () => `${soccer_domain}api/soccer/fixtures/translate/`;
export const MEMBER_OUTSTANDING_API = () => `${soccer_domain}api/soccer/bettings/member-outstanding`;
export const REPORT_NOTI_SENT_API = () => `${soccer_domain}api/soccer/fixtures/send-noti`;

// Lottery API
export const LOTTERY_ODDS_API = () => `${lottery_domain}api/lottery/config/odds`;
export const THREED_OPEN_CLOSE_API = () => `${lottery_domain}api/lottery/config/disable-schedules`;
export const DIGITS_API = () => `${lottery_domain}api/lottery/numbers`;
export const DIGITS_EDIT_API = () => `${lottery_domain}api/lottery/numbers/set-limit-amount`;
export const RESET_DIGITS_API = () => `${lottery_domain}api/lottery/numbers/reset`;
export const LUCKY_NUMBER_API = () => `${lottery_domain}api/lottery/numbers/lucky-numbers`;
export const LUCKY_NUMBER_CREATE_API = () => `${lottery_domain}api/lottery/numbers/lucky-number-create`;
export const LUCKY_NUMBER_APPORVE_API = id =>`${lottery_domain}api/lottery/numbers/lucky-number-win-lose/${id}`;
export const LUCKY_NUMBER_EDIT_API = id =>`${lottery_domain}api/lottery/numbers/lucky-number-update/${id}`;
export const BET_HISTORY_API = () => `${lottery_domain}api/lottery/numbers/lucky-draw`;
export const BETTING_HISTORY_API = () => `${lottery_domain}api/lottery/numbers/bettings`;
export const STOCK_API = () => `${lottery_domain}api/lottery/report/out-standing`;
export const REPORT_API = () => `${lottery_domain}api/lottery/report/3d-report`;
export const THREED_MEMBER_OUTSTANDING_API = () => `${lottery_domain}api/lottery/report/out-standing-balance`;
export const THREED_CURRENT_API = () =>`${lottery_domain}api/lottery/numbers/get-current-time`;
export const THREED_BETTING_REJECT_API = id =>`${lottery_domain}api/lottery/numbers/betting-reject/${id}`;

// Additional API
export const COMMUNITY_API = () => `${additional_domain}api/cms/posts`;
export const CREATE_COMMUNITY_API = () => `${additional_domain}api/cms/posts/create`;
export const MESSAGE_API = () => `${additional_domain}api/cms/noti/messages`;
export const CREATE_MESSAGE_API = () => `${additional_domain}api/cms/noti/create`;
export const SEND_MESSAGE_API = id => `${additional_domain}api/cms/noti/send-noti/${id}`;